const env = window._env_ || process.env;

const config = {
  operatorApiGateway: {
    BASE_URL_1: `${env.REACT_APP_ADMIN_BACKEND_URL_HTTP}`
  }
}

console.log('Operator API Gateway Config:', config.operatorApiGateway);

export default config
